import { render, staticRenderFns } from "./SubmitIdentityVerification.vue?vue&type=template&id=04571ad4&"
import script from "./SubmitIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./SubmitIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports